import { useContext } from "react";
import { StepManagerContext } from "./StepManagerContext";
import { StepManager } from "./StepManager";

export const useStepManager = () => {
  const stepManager = useContext<StepManager | undefined>(StepManagerContext)!;
  return { stepManager };
};
